/**
 * Penguin Pad simulated launchpad vs Pons V2:
 * - Launch fee 0.00025 ETH vs Pons 0.0005 ETH
 * - Trade-fee split 75/25 (creator/platform) vs Pons 70/30
 * - Same 1% quote-leg trade fee and 4.2 ETH graduation
 *
 * Shared economics for the frontend sim and the upcoming factory ABI in `abi.ts`.
 */

export const TOTAL_SUPPLY = 1_000_000_000n * 10n ** 18n // 1B, 18 decimals
export const CURVE_SUPPLY = 800_000_000n * 10n ** 18n // sold on the curve
export const LP_SUPPLY = 200_000_000n * 10n ** 18n // reserved for simulated graduation pool

export const LAUNCH_FEE_ETH = 0.00025
export const GRADUATION_QUOTE_ETH = 4.2
export const PHANTOM_QUOTE_ETH = 0.3 // non-zero start; first buy is not free

export const WAD = 10n ** 18n
export const BPS_DENOM = 10_000n

/** Production createLaunch fee: 0.00025 ETH (1 ETH / 4000). Used by the local sim. */
export const LAUNCH_FEE_WEI = WAD / 4000n
/** Live-release launch fee fallback: matches production 0.00025 ETH, used until the on-chain read resolves. */
export const TEST_LAUNCH_FEE_WEI = LAUNCH_FEE_WEI
/** 4.2 ETH in wei. */
export const GRADUATION_QUOTE_WEI = 42n * 10n ** 17n
/** 0.3 ETH in wei. */
export const PHANTOM_QUOTE_WEI = 3n * 10n ** 17n

export const TRADE_FEE_BPS = 100 // 1.00% on the quote leg — the only trade fee
export const CREATOR_SHARE_BPS = 7500 // 75% of the 1%
export const PLATFORM_SHARE_BPS = 2500 // 25% of the 1%

export const SNIPE_TAX_START_BPS = 9900
export const SNIPE_TAX_DURATION_MS = 5_000 // buys only; linear decay 99% → 0% over 5s

export const SIM_WALLET_START_WEI = 10n * WAD

if (CREATOR_SHARE_BPS + PLATFORM_SHARE_BPS !== 10_000)
  throw new Error('CREATOR_SHARE_BPS + PLATFORM_SHARE_BPS must equal 10000')
